import * as fs from "fs";
import {TokenCacheInitOptions, TokenCache} from "./tokencache";
import {TokenType} from "../base/options";

/*
* 硬盘文件 缓存 初始化参数
* */
export interface DiskCacheInitOptions extends TokenCacheInitOptions {
  /**
   * 缓存路径
   */
  cacheDirPath: string;
  /**
   * 应用token文件名称
   */
  appFileName?: string;
  /**
   * 通讯录token文件名称
   */
  mailFileName?: string;
  /**
   * 打卡token文件名称
   */
  checkInFileName?: string;
  /**
   * 审批token文件名称
   */
  approvalFileName?: string;
}


/**
 * 磁盘缓存
 */
export class DiskCache extends TokenCache {
  private cacheDirPath: string;
  private appFileName: string;
  private mailFileName: string;
  private checkInFileName: string;
  private approvalFileName: string;

  constructor(options: DiskCacheInitOptions) {
    super(options);

    this.cacheDirPath = options.cacheDirPath || "./cache";
    this.appFileName = options.appFileName || "appAccessToken.txt";
    this.mailFileName = options.mailFileName || "mailAccessToken.txt";
    this.checkInFileName = options.checkInFileName || "checkInAccessToken.txt";
    this.approvalFileName = options.approvalFileName || "approvalAccessToken.txt";

    if (!fs.existsSync(this.cacheDirPath)) {
      fs.mkdirSync(this.cacheDirPath);
    }
  }

  /**
   * @override
   */
  async updateToken(type: TokenType, data: string): Promise<void> {
    let fileName: string = this.getFileName_(type);
    // 写入本地文件
    fs.writeFileSync(fileName, data, "utf8");
  }


  /**
   * @override
   */
  async getToken(type: TokenType): Promise<string> {
    let fileName: string = this.getFileName_(type);
    return fs.readFileSync(fileName, "utf8");
  }

  /*
  * 获取保存token的文件
  * */
  private getFileName_(type: TokenType): string {
    switch (type) {
      case 0:
        return this.cacheDirPath + "/" + this.appFileName;
      case 1:
        return this.cacheDirPath + "/" + this.mailFileName;
      case 2:
        return this.cacheDirPath + "/" + this.checkInFileName;
      case 3:
        return this.cacheDirPath + "/" + this.approvalFileName;
    }
    return "";
  }
}

